import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { loadCxbCountries, fetchCxbFeeds, loadCxbUserData, loadCxbUserSegments, fetchGenres, fetchApiVersion } from './app.actions';
import { RootAppState } from './app.reducer';
import { selectIsLoading } from './app.selectors';

@Injectable()
export class AppService {
  public readonly isLoading$: Observable<boolean> = this.store.select(selectIsLoading);

  constructor(private readonly store: Store<RootAppState>) {
    this.store.dispatch(loadCxbUserSegments());
    this.store.dispatch(loadCxbCountries());
    this.store.dispatch(fetchGenres());
    this.store.dispatch(loadCxbUserData());
    this.store.dispatch(fetchApiVersion());
    this.store.dispatch(fetchCxbFeeds.sourceAction());
  }
}
